import React, { useState, useRef, useEffect } from 'react';
import { ButtonLink } from '../Link';
import { VideoLightbox } from '../Video';
import { isLeftAligned } from '../../utils/variations';
import { PlayButton } from '../Buttons';
import { getFieldValue, getParsedField } from '../../utils/helpers';
import { isFieldValid } from '../../utils/validation';
import { DownArrowIcon } from '../Icon';
import { COMPONENT_MARGIN_BOTTOM, NAV_HEADER_HT } from '../../constants';
import { scrollTo } from '../../utils/transitions';
import { HeroContainer, HeroBody, HeroBottomContent, ContainerButton, Title, SecondaryTitle, BodyText, Subtitle, Badge, CTAContainer, } from './Hero.styles';
import { OnClickFocusWrapper } from '../UtilityWrappers';
import { HERO_TITLE_ELEMENT_TYPES } from '../../constants';
import { populateCTAGTM } from '../../utils/gtm';
export const Hero = ({ fields }) => {
    // fields object may be undefined if the datasource item hasn't been published yet
    if (!fields) {
        console.warn('Hero component requires fields to be provided');
        return null;
    }
    const { contentTitle, contentBodyText, contentSubtitle, contentAlignment, desktopImage, mobileImage, badge, ctaLink, playIconText, ctaLinkText, video, videoAltText, closeIconAltText, downArrow, componentBottomMargin, ariaLabel, titleElementType, } = fields;
    const [isVideoOpen, setIsVideoOpen] = useState(false);
    const alignment = getFieldValue(contentAlignment);
    const hasBottomContent = ((isFieldValid(video, 'url') || isFieldValid(badge, 'src')) &&
        isLeftAligned(alignment));
    const hasPlayIcon = isFieldValid(video, 'url') && isLeftAligned(alignment);
    const hasCTALink = isFieldValid(ctaLink, 'href') && isFieldValid(ctaLinkText);
    const videoLabel = getFieldValue(videoAltText);
    const closeIconLabel = getFieldValue(closeIconAltText);
    const hasBottomMargin = getFieldValue(componentBottomMargin);
    const bottomMargin = hasBottomMargin ? COMPONENT_MARGIN_BOTTOM.DESKTOP : 0;
    // parsed values for custom tags
    const parsedTitle = getParsedField(contentTitle);
    const parsedSubtitle = getParsedField(contentSubtitle);
    const parsedBodyText = getParsedField(contentBodyText);
    // handles down arrow functionality
    const ref = useRef(null);
    let scrollOffsetTop = 0;
    useEffect(() => {
        if (!!ref && !!ref.current) {
            scrollOffsetTop =
                ref.current.offsetHeight + ref.current.offsetTop + bottomMargin - NAV_HEADER_HT.DESKTOP;
        }
    });
    return (React.createElement(HeroContainer, { ref: ref, alignment: alignment, hasPaddingBottom: hasPlayIcon, hasPaddingBotOnMobile: hasBottomContent, hasBottomMargin: hasBottomMargin, "aria-label": isFieldValid(ariaLabel) ? ariaLabel.value : '', desktopImage: desktopImage && desktopImage.value && desktopImage.value.src, mobileImage: mobileImage && mobileImage.value && mobileImage.value.src },
        React.createElement("div", { role: "img", "aria-label": getFieldValue(desktopImage, 'alt') }),
        React.createElement(VideoLightbox, { isOpen: isVideoOpen, onClose: () => setIsVideoOpen(false), isContained: true, closeIconLabel: closeIconLabel, videoLabel: videoLabel, video: video }),
        React.createElement(HeroBody, { alignment: alignment },
            isFieldValid(contentTitle) ? (getFieldValue(titleElementType) === HERO_TITLE_ELEMENT_TYPES.H2 ? (React.createElement(SecondaryTitle, { asWhite: true, field: parsedTitle })) : (React.createElement(Title, { asWhite: true, field: parsedTitle }))) : null,
            isFieldValid(contentBodyText) && React.createElement(BodyText, { asWhite: true, field: parsedBodyText }),
            isFieldValid(contentSubtitle) && React.createElement(Subtitle, { asWhite: true, field: parsedSubtitle }),
            hasCTALink && (React.createElement(CTAContainer, { alignment: alignment },
                React.createElement(ButtonLink, Object.assign({ field: ctaLink, textField: ctaLinkText }, populateCTAGTM(fields)))))),
        hasBottomContent && (React.createElement(HeroBottomContent, { alignment: alignment, hasBadgeOnly: isFieldValid(badge, 'src') && !isFieldValid(video, 'url'), hasPlayBtnOnly: isFieldValid(video, 'url') && !isFieldValid(badge, 'src') },
            hasPlayIcon && (React.createElement(PlayButton, { onClick: () => {
                    setIsVideoOpen(true);
                }, textField: playIconText, asWhite: true })),
            isFieldValid(badge, 'src') && isLeftAligned(alignment) && React.createElement(Badge, { media: badge }))),
        isFieldValid(downArrow) && (React.createElement(OnClickFocusWrapper, null,
            React.createElement(ContainerButton, { onClick: () => {
                    scrollTo(0, scrollOffsetTop, 'smooth');
                } },
                React.createElement(DownArrowIcon, null))))));
};
